var React = require('react');

function LinkedinIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M3 0a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V3a3 3 0 0 0-3-3H3Zm14 15.802v-4.618a11.407 11.407 0 0 0-.065-1.229c-.106-.838-.354-1.522-.866-2.006-.509-.48-1.27-.749-2.397-.749-.639 0-1.184.114-1.62.318a2.386 2.386 0 0 0-.69.472v-.594a.198.198 0 0 0-.196-.196H8.818a.198.198 0 0 0-.195.196v8.406c0 .106.09.195.195.195h2.453c.106 0 .196-.09.196-.195v-4.166c0-.521.048-1.03.248-1.4.187-.337.525-.565 1.119-.565.573 0 .882.264 1.045.635.18.398.204.931.204 1.403v4.093c0 .106.09.195.2.195h2.522c.11 0 .195-.09.195-.195ZM7.336 7.4v8.406c0 .106-.09.195-.2.195H4.2C4.09 16 4 15.911 4 15.805V7.4a.2.2 0 0 1 .2-.195h2.937c.11 0 .2.09.2.195Zm-.475-1.563a1.668 1.668 0 1 0-.012.012l.012-.012Z","fill":"currentColor"}));
}

LinkedinIcon.defaultProps = {"viewBox":"0 0 20 20","fill":"none"};

module.exports = LinkedinIcon;

LinkedinIcon.default = LinkedinIcon;
